document.addEventListener('DOMContentLoaded', function() {
  var state = { phase: null, voltage: null, amp: null, trueHp: null, hp: null, rpm: null, frame: null };
  var PF = 0.85, EFF = 0.90;

  var CATALOG = window.MCF_CATALOG || [];
  if (CATALOG.length === 0) {
    console.warn('MCF: No catalog data found. Ensure the page template is passing window.MCF_CATALOG.');
  }
  var VOLTAGES = {
    1: [
      { label: '110-115V', min: 110, max: 115 },
      { label: '208-230V', min: 208, max: 230 }
    ],
    3: [
      { label: '208-230V', min: 208, max: 230 },
      { label: '440-460V', min: 440, max: 460 },
      { label: '575V',     min: 560, max: 590 }
    ]
  };
  var HP_STEPS = [0.5, 0.75, 1, 1.5, 2, 3, 5, 7.5, 10];

  function calcTrueHp(amps, volts, phase) {
    var pf = phase === 3 ? Math.sqrt(3) : 1;
    return (volts * amps * PF * EFF * pf) / 746;
  }

  function closestHp(hp) {
    return HP_STEPS.reduce(function(a, b) { return Math.abs(b - hp) < Math.abs(a - hp) ? b : a; });
  }

  function setProgress(step) {
    document.getElementById('mcf-progress-fill').style.width = (step / 5 * 100) + '%';
    document.getElementById('mcf-progress-label').textContent = 'Step ' + step + ' of 5';
  }

  function goTo(step) {
    document.querySelectorAll('.mcf-step').forEach(function(el) { el.classList.remove('active'); });
    document.getElementById('mcf-step-' + step).classList.add('active');
    setProgress(step);
    document.getElementById('mcf-tool').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  window.mcfGoBack = function(from) { goTo(from - 1); };

  window.mcfRestart = function() {
    state = { phase: null, voltage: null, amp: null, trueHp: null, hp: null, rpm: null, frame: null };
    document.querySelectorAll('.mcf-option').forEach(function(el) { el.classList.remove('selected'); });
    document.querySelectorAll('.mcf-input').forEach(function(el) { el.value = ''; });
    document.querySelectorAll('.mcf-select').forEach(function(el) { el.selectedIndex = 0; });
    ['mcf-next-1','mcf-next-2','mcf-next-3','mcf-next-4'].forEach(function(id) {
      document.getElementById(id).disabled = true;
    });
    document.getElementById('mcf-amp-preview').style.display = 'none';
    document.getElementById('mcf-hp-mismatch').style.display = 'none';
    document.getElementById('mcf-spl-callout').style.display = 'none';
    goTo(1);
  };

  /* Step 1 */
  document.querySelectorAll('#mcf-step-1 .mcf-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      document.querySelectorAll('#mcf-step-1 .mcf-option').forEach(function(o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      state.phase = parseInt(opt.dataset.val);
      document.getElementById('mcf-next-1').disabled = false;
    });
  });
  document.getElementById('mcf-next-1').addEventListener('click', function() {
    buildVoltageOptions();
    goTo(2);
  });

  function buildVoltageOptions() {
    var c = document.getElementById('mcf-voltage-options');
    c.innerHTML = '';
    VOLTAGES[state.phase].forEach(function(v) {
      var d = document.createElement('div');
      d.className = 'mcf-option';
      d.innerHTML = '<span class="mcf-option-title">' + v.label + '</span>';
      d.addEventListener('click', function() {
        document.querySelectorAll('#mcf-voltage-options .mcf-option').forEach(function(o) { o.classList.remove('selected'); });
        d.classList.add('selected');
        state.voltage = v;
        document.getElementById('mcf-next-2').disabled = false;
      });
      c.appendChild(d);
    });
  }

  /* Step 2 */
  document.getElementById('mcf-next-2').addEventListener('click', function() { goTo(3); });

  /* Step 3 */
  var ampInput = document.getElementById('mcf-amp-input');
  ampInput.addEventListener('input', function() {
    var amp = parseFloat(ampInput.value);
    var preview = document.getElementById('mcf-amp-preview');
    if (!amp || amp <= 0) {
      preview.style.display = 'none';
      document.getElementById('mcf-next-3').disabled = true;
      return;
    }
    state.amp = amp;
    var volts = state.voltage ? Math.round((state.voltage.min + state.voltage.max) / 2) : 230;
    var trueHp = calcTrueHp(amp, volts, state.phase);
    state.trueHp = trueHp;
    var rounded = Math.round(trueHp * 10) / 10;
    preview.style.display = 'block';
    preview.innerHTML = 'Based on <strong>' + amp + 'A at ' + volts + 'V</strong>, your motor\'s estimated true output is <strong>~' + rounded + ' HP</strong>.';
    document.getElementById('mcf-next-3').disabled = false;
  });

  document.getElementById('mcf-next-3').addEventListener('click', function() {
    goTo(4);
    showMismatchWarning();
  });

  function showMismatchWarning() {
    if (state.hp === 'SPL') return;
    var el = document.getElementById('mcf-hp-mismatch');
    var trueHpClosest = closestHp(state.trueHp);
    var volts = state.voltage ? Math.round((state.voltage.min + state.voltage.max) / 2) : 230;
    var rounded = Math.round(state.trueHp * 10) / 10;
    el.innerHTML = '<div class="mcf-callout mcf-callout-warn"><strong>Heads up:</strong> Based on ' + state.amp + 'A at ' + volts + 'V, your motor\'s estimated true output is ~' + rounded + ' HP. If your nameplate shows a higher number, it may be a peak rating. We\'ll surface amp-verified results first.</div>';
    el.style.display = 'block';
  }

  /* Step 4 */
  function checkStep4() {
    var hpOk = state.hp === 'SPL' || !!state.hp;
    document.getElementById('mcf-next-4').disabled = !(hpOk && state.rpm && state.frame);
  }
  document.getElementById('mcf-hp-select').addEventListener('change', function(e) {
    var val = e.target.value;
    state.hp = val === 'SPL' ? 'SPL' : (parseFloat(val) || null);
    var splCallout = document.getElementById('mcf-spl-callout');
    var mismatchDiv = document.getElementById('mcf-hp-mismatch');
    if (state.hp === 'SPL') {
      splCallout.style.display = 'block';
      mismatchDiv.style.display = 'none';
    } else {
      splCallout.style.display = 'none';
      if (state.trueHp) showMismatchWarning();
    }
    checkStep4();
  });
  document.getElementById('mcf-rpm-select').addEventListener('change', function(e) {
    var val = e.target.value;
    if (val === 'low') { state.rpm = { label: '1600-1800 RPM', min: 1600, max: 1800 }; }
    else if (val === 'high') { state.rpm = { label: '3400-3600 RPM', min: 3400, max: 3600 }; }
    else { state.rpm = null; }
    checkStep4();
  });
  document.getElementById('mcf-frame-select').addEventListener('change', function(e) { state.frame = e.target.value || null; checkStep4(); });
  document.getElementById('mcf-next-4').addEventListener('click', function() {
    buildResults();
    goTo(5);
  });

  var FRAME_ALIASES = {
    'W182/4T': '182/4T',
    'W213/5T': '213/5T',
    '213/5TZ': '213/5T',
    'W56':     '56'
  };
  function normalizeFrame(f) {
    return FRAME_ALIASES[f] || f;
  }

  function scoreMotor(motor, hpOverride) {
    var hp = hpOverride !== undefined ? hpOverride : state.hp;
    var score = 0;
    var r = { phase: false, voltage: false, hp: false, rpm: false, amp: false, frame: false };
    if (motor.phase === state.phase) { score += 3; r.phase = true; }
    if (state.voltage && motor.voltage >= state.voltage.min && motor.voltage <= state.voltage.max) { score += 3; r.voltage = true; }
    if (motor.hp === hp) { score += 3; r.hp = true; }
    if (state.rpm && motor.rpm >= state.rpm.min && motor.rpm <= state.rpm.max) { score += 2; r.rpm = true; }
    if (state.amp && motor.amp && Math.abs(motor.amp - state.amp) <= state.amp * 0.10) { score += 2; r.amp = true; }
    if (state.frame && normalizeFrame(motor.frame) === normalizeFrame(state.frame)) { score += 2; r.frame = true; }
    return { score: score, reasons: r };
  }

  function makeCard(scored, badge, badgeClass, isBest) {
    var m = scored.motor;
    var r = scored.reasons;
    var card = document.createElement('div');
    card.className = 'mcf-result-card' + (isBest ? ' best' : '');
    var specs = [
      { label: m.phase + '-phase', key: 'phase' },
      { label: m.voltage + 'V', key: 'voltage', match: state.voltage && m.voltage >= state.voltage.min && m.voltage <= state.voltage.max },
      { label: m.hp + ' HP', key: 'hp' },
      { label: m.rpm + ' RPM', key: 'rpm', match: state.rpm && m.rpm >= state.rpm.min && m.rpm <= state.rpm.max },
      { label: m.amp + 'A', key: 'amp' },
      { label: m.frame, key: 'frame' }
    ];
    var pills = specs.map(function(s) {
      var isMatch = s.hasOwnProperty('match') ? s.match : r[s.key];
      return '<span class="mcf-pill ' + (isMatch ? 'match' : '') + '">' + s.label + '</span>';
    }).join('');
    card.innerHTML =
      '<div style="flex:1;min-width:0;">' +
        '<span class="mcf-result-badge ' + badgeClass + '">' + badge + '</span>' +
        '<div class="mcf-result-name">' + m.name + '</div>' +
        '<div class="mcf-result-sku">SKU: ' + m.sku + '</div>' +
        '<div class="mcf-result-pills">' + pills + '</div>' +
      '</div>' +
      '<div class="mcf-result-right">' +
        '<div class="mcf-result-price">$' + m.price + '</div>' +
        '<a class="mcf-btn mcf-btn-primary" href="' + m.url + '" style="font-size:13px;padding:8px 16px;">View product</a>' +
      '</div>';
    return card;
  }

  function buildResults() {
    var list = document.getElementById('mcf-results-list');
    list.innerHTML = '';
    var warning = document.getElementById('mcf-results-warning');
    var isSpl = state.hp === 'SPL';
    var trueHpClosest = closestHp(state.trueHp);
    var mismatch = !isSpl && state.hp > trueHpClosest * 1.4;
    var volts = state.voltage ? Math.round((state.voltage.min + state.voltage.max) / 2) : 230;
    var rounded = Math.round(state.trueHp * 10) / 10;

    if (isSpl) {
      warning.style.display = 'block';
      warning.innerHTML = '<div class="mcf-callout mcf-callout-warn" style="margin-bottom:16px;"><strong>Your motor is labeled SPL — we are matching on amp rating only.</strong> SPL motors have no reliable HP rating, so we have used your amp reading (' + state.amp + 'A at ' + volts + 'V) to estimate a true output of ~' + rounded + ' HP. Results below are based on that calculation.</div>';
    } else if (mismatch) {
      warning.style.display = 'block';
      warning.innerHTML = '<div class="mcf-callout mcf-callout-warn" style="margin-bottom:16px;"><strong>Your motor may be labeled above its true output.</strong> Based on ' + state.amp + 'A at ' + volts + 'V, the estimated true HP is ~' + rounded + ' HP, not ' + state.hp + ' HP. Amp-verified replacements are shown first. See labeled-HP options below for reference.</div>';
    } else {
      warning.style.display = 'none';
    }

    var chips = document.getElementById('mcf-spec-chips');
    var chipValues = [
      state.phase + '-phase', state.voltage.label,
      isSpl ? 'SPL (labeled)' : state.hp + ' HP (labeled)',
      '~' + rounded + ' HP (amp-verified)',
      state.rpm.label, state.amp + 'A', state.frame
    ];
    chips.innerHTML = chipValues.map(function(t) { return '<span class="mcf-chip">' + t + '</span>'; }).join('');

    var trueMatches = CATALOG.map(function(m) {
      var s = scoreMotor(m, trueHpClosest);
      return { motor: m, score: s.score, reasons: s.reasons };
    }).filter(function(r) { return r.reasons.phase && r.reasons.voltage && r.reasons.rpm && r.reasons.frame; })
      .sort(function(a, b) { return b.score - a.score; });

    if (isSpl) {
      document.getElementById('mcf-results-title').textContent = 'Amp-verified replacements for your SPL motor';
      if (trueMatches.length === 0) {
        list.innerHTML = '<div class="mcf-no-results">No motors matched your specs. Use the "Talk to an expert" button below.</div>';
      } else {
        trueMatches.slice(0, 4).forEach(function(r, i) {
          list.appendChild(makeCard(r, i === 0 ? 'Best match' : 'Compatible', i === 0 ? 'mcf-badge-best' : 'mcf-badge-alt', i === 0));
        });
      }
    } else if (mismatch) {
      document.getElementById('mcf-results-title').textContent = 'Results for your motor';
      if (trueMatches.length > 0) {
        var lbl1 = document.createElement('div');
        lbl1.className = 'mcf-section-divider';
        lbl1.textContent = 'Amp-verified replacements (recommended)';
        list.appendChild(lbl1);
        trueMatches.slice(0, 3).forEach(function(r, i) {
          list.appendChild(makeCard(r, i === 0 ? 'Best match' : 'Compatible', i === 0 ? 'mcf-badge-best' : 'mcf-badge-alt', i === 0));
        });
      }
      var labeledMatches = CATALOG.map(function(m) {
        var s = scoreMotor(m, state.hp);
        return { motor: m, score: s.score, reasons: s.reasons };
      }).filter(function(r) { return r.reasons.phase && r.reasons.voltage && r.reasons.rpm && r.reasons.frame && r.motor.hp === state.hp; })
        .sort(function(a, b) { return b.score - a.score; });
      if (labeledMatches.length > 0) {
        var lbl2 = document.createElement('div');
        lbl2.className = 'mcf-section-divider';
        lbl2.textContent = 'Motors labeled at ' + state.hp + ' HP';
        list.appendChild(lbl2);
        labeledMatches.slice(0, 2).forEach(function(r) {
          list.appendChild(makeCard(r, 'Labeled ' + state.hp + ' HP', 'mcf-badge-alt', false));
        });
      }
    } else {
      document.getElementById('mcf-results-title').textContent =
        trueMatches.length > 0
          ? trueMatches.length + ' compatible motor' + (trueMatches.length !== 1 ? 's' : '') + ' found'
          : 'No exact matches found';
      if (trueMatches.length === 0) {
        list.innerHTML = '<div class="mcf-no-results">No motors matched your specs. Use the "Talk to an expert" button below — we will help you find the right fit.</div>';
      } else {
        trueMatches.slice(0, 4).forEach(function(r, i) {
          list.appendChild(makeCard(r, i === 0 ? 'Best match' : 'Compatible', i === 0 ? 'mcf-badge-best' : 'mcf-badge-alt', i === 0));
        });
      }
    }
  }

  /* Nameplate legend hover interactions */
  document.querySelectorAll('.mcf-legend-item').forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      var field = item.dataset.field;
      document.querySelectorAll('.mcf-legend-item').forEach(function(i) { i.classList.remove('active'); });
      item.classList.add('active');
      document.querySelectorAll('.mcf-nameplate-field').forEach(function(f) {
        f.classList.toggle('active', f.dataset.highlight === field);
      });
    });
    item.addEventListener('mouseleave', function() {
      item.classList.remove('active');
      document.querySelectorAll('.mcf-nameplate-field').forEach(function(f) { f.classList.remove('active'); });
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('.mcf-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.mcf-faq-item');
      var answer = item.querySelector('.mcf-faq-a');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.mcf-faq-item').forEach(function(i) {
        i.classList.remove('open');
        i.querySelector('.mcf-faq-a').style.maxHeight = '0';
        i.querySelector('.mcf-faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  setProgress(1);
});